import React, { Component } from 'react';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import AppModuleHeader from 'components/AppModuleHeader/index';
import OrgSurveyList from 'components/Agile/OrgSurvey/OrgSurveyList';
import AddOrgSurvey from 'components/Agile/OrgSurvey/AddOrgSurvey';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';

import {
    fetchOrgSurveys,
    onAddOrgSurvey,
    onOrgSurveyClose,
    onSaveOrgSurvey,
    onToggleOrgSurveyDrawer,
    hideOrgSurveyLoader,
    showOrgSurveyLoader,
    handleOrgSurveyRequestClose,
} from 'actions/OrgSurvey';

class OrgSurvey extends Component {
    orgSurveySideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.surveys" /></span>
                </div>
            </div>

            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={this.onAddOrgSurvey}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="survey.addSurvey" /></span>
                        </Button>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;

    };

    onAddOrgSurvey = () => {
        this.props.onAddOrgSurvey();
    };
    onOrgSurveyClose = () => {
        this.props.onOrgSurveyClose();
    };
    onSaveOrgSurvey = (data) => {
        this.props.onSaveOrgSurvey(data);
    };
    onDeleteOrgSurvey = (data) => {
        this.props.onDeleteOrgSurvey(data);
    };
    handleOrgSurveyRequestClose = () => {
        this.props.handleOrgSurveyRequestClose();
    };
    onToggleOrgSurveyDrawer = () => {
        this.props.onToggleOrgSurveyDrawer();
    };
    showOrgSurveyLoader = () => {
        this.props.showOrgSurveyLoader();
    };
    showSurveyLoader = () => {
        this.props.showSurveyLoader();
    };

    constructor() {
        super();
    }

    componentDidMount() {
        this.props.showOrgSurveyLoader();
        this.props.fetchOrgSurveys();
    }

    render() {
        const {
            addOrgSurveyState,
            alertMessage,
            showMessage,
            drawerState,
            noContentFoundMessage,
            loader,
            selectedOrg,
            surveyList,
            org,
            searchOrgSurvey,
        } = this.props;
        return (
            <div className="app-wrapper">
                <div className="app-module animated slideInUpTiny animation-duration-3">

                    <div className="d-block d-xl-none">
                        <Drawer
                            touch={true}
                            transitions={true}
                            enableDragHandle={true}
                            open={drawerState}
                            onOpenChange={this.onToggleOrgSurveyDrawer.bind(this)}
                            sidebar={this.orgSurveySideBar(selectedOrg)} />
                    </div>
                    <div className="app-module-sidenav d-none d-xl-flex">
                        {this.orgSurveySideBar(selectedOrg)}
                    </div>

                    <div className="module-box">
                        <div className="module-box-header">
                            <span className="icon-btn drawer-btn d-flex d-xl-none"
                                onClick={this.onToggleOrgSurveyDrawer.bind(this)}>
                                <i className="zmdi zmdi-menu" />
                            </span>
                            <AppModuleHeader placeholder="Search Unavailable" notification={false} apps={false}
                                user={org}
                                onChange={() => { }}
                                value={searchOrgSurvey} />
                        </div>
                        <div className="module-box-content">
                            <CustomScrollbars className="module-list-scroll scrollbar"
                                style={{ height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)' }}>
                                {loader ?
                                    <div
                                        className="loader-view-block h-100">
                                        <div className="loader-view">
                                            <CircularProgress />
                                        </div>
                                    </div>
                                    :
                                    selectedOrg ?.surveys ?.length === 0 ?
                                        <div className="h-100 d-flex align-items-center justify-content-center">
                                            {noContentFoundMessage}
                                        </div>
                                        : <OrgSurveyList
                                            surveys={surveyList}
                                            selectedOrg={selectedOrg}
                                            onSaveOrgSurvey={this.onSaveOrgSurvey.bind(this)}
                                            showOrgSurveyLoader={this.showOrgSurveyLoader.bind(this)} />
                                }
                            </CustomScrollbars>

                        </div>
                    </div>
                </div>
                <AddOrgSurvey
                    surveys={surveyList}
                    open={addOrgSurveyState}
                    orgSurvey={{
                        id: '',
                        name: '',
                        startDate: '',
                        endDate: '' 
                    }}
                    onSaveOrgSurvey={this.onSaveOrgSurvey.bind(this)}
                    onOrgSurveyClose={this.onOrgSurveyClose.bind(this)}
                    showOrgSurveyLoader={this.showOrgSurveyLoader.bind(this)}
                />

                {showMessage && NotificationManager.success(alertMessage, this.handleOrgSurveyRequestClose())}
                <NotificationContainer />

            </div>
        )
    }
}

const mapStateToProps = ({ orgs, surveys, settings, orgSurveys }) => {
    const { width } = settings;
    const {
        selectedOrg,
        org,
    } = orgs;
    const {
        surveyList,
    } = surveys;
    const {
        loader,
        alertMessage,
        showMessage,
        drawerState,
        searchOrgSurvey,
        addOrgSurveyState,
    } = orgSurveys;
    return {
        org,
        width,
        loader,
        alertMessage,
        showMessage,
        drawerState,
        selectedOrg,
        surveyList,
        searchOrgSurvey,
        addOrgSurveyState,
    };
};
export default connect(mapStateToProps, {
    fetchOrgSurveys,
    showOrgSurveyLoader,
    hideOrgSurveyLoader,
    onAddOrgSurvey,
    onOrgSurveyClose,
    onSaveOrgSurvey,
    onToggleOrgSurveyDrawer,
    handleOrgSurveyRequestClose,
})(OrgSurvey);


// WEBPACK FOOTER //
// ./components/Agile/OrgSurvey/index.js